/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EnableDisableSchema } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { PagePlatformControlDetailed } from '../model';
// @ts-ignore
import type { PagePlatformFrameworkVersionOverview } from '../model';
// @ts-ignore
import type { PagePlatformRequirementDetailed } from '../model';
// @ts-ignore
import type { PlatformFrameworkVersionOverview } from '../model';
// @ts-ignore
import type { ReleaseNotesResponse } from '../model';
/**
 * PlatformFrameworksApi - axios parameter creator
 */
export const PlatformFrameworksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Platform Frameworks
         * @param {File} file 
         * @param {string | null} [releaseNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlatformFrameworksPlatformFrameworksPost: async (file: File, releaseNotes?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createPlatformFrameworksPlatformFrameworksPost', 'file', file)
            const localVarPath = `/platform-frameworks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (releaseNotes !== undefined) { 
                localVarFormParams.append('release_notes', releaseNotes as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable Disable Platform Framework For Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {EnableDisableSchema} enableDisableSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost: async (frameworkCode: string, organizationId: string, enableDisableSchema: EnableDisableSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost', 'organizationId', organizationId)
            // verify required parameter 'enableDisableSchema' is not null or undefined
            assertParamExists('enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost', 'enableDisableSchema', enableDisableSchema)
            const localVarPath = `/platform-frameworks/{framework_code}/organizations/{organization_id}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableDisableSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {string} frameworkCode 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet: async (frameworkCode: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet', 'frameworkCode', frameworkCode)
            const localVarPath = `/platform-frameworks/{framework_code}/controls`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Platform Framework
         * @param {string} frameworkCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkPlatformFrameworksFrameworkCodeGet: async (frameworkCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkPlatformFrameworksFrameworkCodeGet', 'frameworkCode', frameworkCode)
            const localVarPath = `/platform-frameworks/{framework_code}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {string} frameworkCode 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet: async (frameworkCode: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet', 'frameworkCode', frameworkCode)
            const localVarPath = `/platform-frameworks/{framework_code}/requirements`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Platform Framework Version
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet: async (frameworkCode: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet', 'version', version)
            const localVarPath = `/platform-frameworks/{framework_code}/versions/{version}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{version}', encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Platform Framework Versions
         * @param {string} frameworkCode 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet: async (frameworkCode: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet', 'frameworkCode', frameworkCode)
            const localVarPath = `/platform-frameworks/{framework_code}/versions`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Updated Frameworks From Zip File
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost', 'file', file)
            const localVarPath = `/platform-frameworks/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformFrameworksApi - functional programming interface
 */
export const PlatformFrameworksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformFrameworksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Platform Frameworks
         * @param {File} file 
         * @param {string | null} [releaseNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlatformFrameworksPlatformFrameworksPost(file: File, releaseNotes?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlatformFrameworksPlatformFrameworksPost(file, releaseNotes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.createPlatformFrameworksPlatformFrameworksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable Disable Platform Framework For Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {EnableDisableSchema} enableDisableSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost(frameworkCode: string, organizationId: string, enableDisableSchema: EnableDisableSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost(frameworkCode, organizationId, enableDisableSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {string} frameworkCode 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet(frameworkCode: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformControlDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet(frameworkCode, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Platform Framework
         * @param {string} frameworkCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkPlatformFrameworksFrameworkCodeGet(frameworkCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkPlatformFrameworksFrameworkCodeGet(frameworkCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.getPlatformFrameworkPlatformFrameworksFrameworkCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {string} frameworkCode 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet(frameworkCode: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformRequirementDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet(frameworkCode, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Platform Framework Version
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet(frameworkCode: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet(frameworkCode, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Platform Framework Versions
         * @param {string} frameworkCode 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet(frameworkCode: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet(frameworkCode, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Updated Frameworks From Zip File
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlatformFrameworksApi - factory interface
 */
export const PlatformFrameworksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformFrameworksApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Platform Frameworks
         * @param {PlatformFrameworksApiCreatePlatformFrameworksPlatformFrameworksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlatformFrameworksPlatformFrameworksPost(requestParameters: PlatformFrameworksApiCreatePlatformFrameworksPlatformFrameworksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createPlatformFrameworksPlatformFrameworksPost(requestParameters.file, requestParameters.releaseNotes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable Disable Platform Framework For Organization
         * @param {PlatformFrameworksApiEnableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost(requestParameters: PlatformFrameworksApiEnableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.enableDisableSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {PlatformFrameworksApiGetPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformControlDetailed> {
            return localVarFp.getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet(requestParameters.frameworkCode, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Platform Framework
         * @param {PlatformFrameworksApiGetPlatformFrameworkPlatformFrameworksFrameworkCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkPlatformFrameworksFrameworkCodeGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkPlatformFrameworksFrameworkCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getPlatformFrameworkPlatformFrameworksFrameworkCodeGet(requestParameters.frameworkCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {PlatformFrameworksApiGetPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformRequirementDetailed> {
            return localVarFp.getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet(requestParameters.frameworkCode, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Platform Framework Version
         * @param {PlatformFrameworksApiGetPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Platform Framework Versions
         * @param {PlatformFrameworksApiGetPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformFrameworkVersionOverview> {
            return localVarFp.getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet(requestParameters.frameworkCode, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Updated Frameworks From Zip File
         * @param {PlatformFrameworksApiGetUpdatedFrameworksFromZipFilePlatformFrameworksValidatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost(requestParameters: PlatformFrameworksApiGetUpdatedFrameworksFromZipFilePlatformFrameworksValidatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseNotesResponse> {
            return localVarFp.getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPlatformFrameworksPlatformFrameworksPost operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiCreatePlatformFrameworksPlatformFrameworksPostRequest {
    readonly file: File

    readonly releaseNotes?: string | null
}

/**
 * Request parameters for enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiEnableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPostRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    readonly enableDisableSchema: EnableDisableSchema
}

/**
 * Request parameters for getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiGetPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGetRequest {
    readonly frameworkCode: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformFrameworkPlatformFrameworksFrameworkCodeGet operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiGetPlatformFrameworkPlatformFrameworksFrameworkCodeGetRequest {
    readonly frameworkCode: string
}

/**
 * Request parameters for getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiGetPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGetRequest {
    readonly frameworkCode: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiGetPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGetRequest {
    readonly frameworkCode: string

    readonly version: string
}

/**
 * Request parameters for getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiGetPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGetRequest {
    readonly frameworkCode: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiGetUpdatedFrameworksFromZipFilePlatformFrameworksValidatePostRequest {
    readonly file: File
}

/**
 * PlatformFrameworksApi - object-oriented interface
 */
export class PlatformFrameworksApi extends BaseAPI {
    /**
     * 
     * @summary Create Platform Frameworks
     * @param {PlatformFrameworksApiCreatePlatformFrameworksPlatformFrameworksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlatformFrameworksPlatformFrameworksPost(requestParameters: PlatformFrameworksApiCreatePlatformFrameworksPlatformFrameworksPostRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).createPlatformFrameworksPlatformFrameworksPost(requestParameters.file, requestParameters.releaseNotes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable Disable Platform Framework For Organization
     * @param {PlatformFrameworksApiEnableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost(requestParameters: PlatformFrameworksApiEnableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPostRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).enableDisablePlatformFrameworkForOrganizationPlatformFrameworksFrameworkCodeOrganizationsOrganizationIdPost(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.enableDisableSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
     * @summary Get Platform Framework Controls
     * @param {PlatformFrameworksApiGetPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).getPlatformFrameworkControlsPlatformFrameworksFrameworkCodeControlsGet(requestParameters.frameworkCode, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Platform Framework
     * @param {PlatformFrameworksApiGetPlatformFrameworkPlatformFrameworksFrameworkCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkPlatformFrameworksFrameworkCodeGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkPlatformFrameworksFrameworkCodeGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).getPlatformFrameworkPlatformFrameworksFrameworkCodeGet(requestParameters.frameworkCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
     * @summary Get Platform Framework Requirements
     * @param {PlatformFrameworksApiGetPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).getPlatformFrameworkRequirementsPlatformFrameworksFrameworkCodeRequirementsGet(requestParameters.frameworkCode, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Platform Framework Version
     * @param {PlatformFrameworksApiGetPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).getPlatformFrameworkVersionPlatformFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Platform Framework Versions
     * @param {PlatformFrameworksApiGetPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet(requestParameters: PlatformFrameworksApiGetPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).getPlatformFrameworkVersionsPlatformFrameworksFrameworkCodeVersionsGet(requestParameters.frameworkCode, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Updated Frameworks From Zip File
     * @param {PlatformFrameworksApiGetUpdatedFrameworksFromZipFilePlatformFrameworksValidatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost(requestParameters: PlatformFrameworksApiGetUpdatedFrameworksFromZipFilePlatformFrameworksValidatePostRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).getUpdatedFrameworksFromZipFilePlatformFrameworksValidatePost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

